import React, { Component } from 'react'
import { Card, Button } from '@blueprintjs/core'
import { push } from 'connected-react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRightFromBracket } from '@fortawesome/pro-regular-svg-icons/faRightFromBracket'
import { LIST_PATH } from '../../constants/paths'
import { connect } from 'react-redux'
import styles from './logout.module.scss'

class Logout extends Component {
    render() {
        return (
            <div>
                <Card className={styles.logoutCard}>
                    <div className={styles.logoutCardBody}>
                        <FontAwesomeIcon icon={faRightFromBracket} className={styles.logoutIcon} />
                        <div className={styles.logoutContent}>
                            <div className={styles.logoutTitle}>
                                Are you sure you want to logout?
                            </div>
                            <div className={styles.logoutBtnGroup}>
                                <Button
                                    onClick={() =>
                                        this.props.dispatch(push(LIST_PATH))
                                    }
                                >
                                    No
                                </Button>
                                <Button
                                    onClick={() =>
                                        (window.location.href = '/sso-logout')
                                    }
                                >
                                    Yes
                                </Button>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    dispatch,
})

export default connect(null, mapDispatchToProps)(Logout)
